<template src='./CuestionarioSeguimiento.html'></template>

<script>
import { consultarMarcacionesEncuentro } from "../../../apiService/request/CrudEncuentro";
import redes from "../../../js/redes";
import { serverBus } from "../../../main";
import {
  actualizarCuestionario,
  crearCuestionario
} from "../../../apiService/request/CrudSeguimiento";
import TarjetasNuevasMomento from "../../TarjetasNuevasMomento/TrajetasNuevasMomento";
import TarjetasFormulariosMomentos from "../../TarjetasFormulariosMomentos/TarjetasFormulariosMomentos";
import metodos_comunes from "../../../js/metodos_comunes";
import { reemplazarCaracteresEspeciales } from "../../../js/metodos_comunes";
import { actualizarFormulario } from "../../../apiService/request/CrudFormulario.js";

export default {
  data() {
    return {
      posicionFormulario: -1,
      mostrarFormularioCompleto: false,
      mostrarRespuestaFormulario: false,
      formularioSeleccionado: "",
      flechaArriba: false,
      jsonValorSeleccionado: [],
      colorRojo: false,
      colorAmarillo: false,
      valorResultado: Number,
      arrayVariablesActualizar: [],
      banderaOcultarFlecha: false,
      panel: Number,
      arrayFormulariosLlenados: [],
      contenidoVisible: false,
      valid: false,
    };
  },
  components: {
    TarjetasNuevasMomento,
    TarjetasFormulariosMomentos,
  },
  props: {
    texto_introductorio: {
      type: String,
      default: null
    },
    nombreFormularioCreado: {
      type: String,
      default: null
    },
    prioridadComponente: {
      type: Number,
      default: 1
    },
    listaCuestionarios: Array,
    index: Number,
    preguntasEncuestas: Array,
    keyFormulario: String,
    deshabilitado: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$store.dispatch("setPrioridadComponente", this.prioridadComponente);
  },
  beforeDestroy() {
    this.$store.dispatch("setPrioridadComponente", 1);
  },
  computed: {
    getVariablesFormularios() {
      return this.$store.getters.getVariablesFormularios;
    },
    getBanderaFormularioExistenteAbierto() {
      return this.$store.getters.getBanderaFormularioExistenteAbierto;
    },
    valorSeleccionado() {
     if (this.getVariablesFormularios) {
       return this.getVariablesFormularios.map(dato => dato.valor)
     } 
     return []
    },
    opcionesSeleccionadas () {
      return this.valorSeleccionado.map((valor, index) => {
        return {
          nombre: `variable${index + 1}`,
          valor: valor
          }
      });
    },
    opcionesMapeadas () {
      return this.opcionesSeleccionadas.map(opcion => {
            if (opcion.valor === "Sí") {
              return 1;
            } else if (opcion.valor === "No"){
              return 0;
            }
          });
    },
    valorMensajeResultado() {
      const resultado_red = redes.logica_marcaciones(this.opcionesMapeadas);
      return resultado_red.indexOf(Math.max(...resultado_red));
    },
    mensajeResultado() {
      switch(this.valorMensajeResultado) {
        case 0:
          return "Adjuntar en observación el motivo de la llamada";
        case 1:
          return "Asignar cita prioritaria";
        case 2:
          return "Indicar cómo realizar el ciclo de rescate";
        case 3:
          return "Remitir a urgencias";
        default:
          return null;
      }
    },
  },
  beforeUpdate: function() {
    if (this.preguntasEncuestas.length == 0) {
      this.arrayVariablesActualizar = [];
      this.flechaArriba = true;
      this.jsonValorSeleccionado = [];
      this.mostrarRespuestaFormulario = false;
    }
  },
  methods: {
    reiniciarPanelExpansible() {
      this.panel = null;
      this.formularioSeleccionado = "";
    },
    consultarFormulario() {
      serverBus.$emit("consultarCuestionarioExistente", true);
    },
    MostrarFormulario(nombreformulario, index) {
      if (this.panel !== null && this.panel>=0) {
        this.formularioSeleccionado = ""
        // this.valorSeleccionado = []
        if (this.posicionFormulario === index) {
          return;
        }
      }
      this.posicionFormulario = index;
      this.$store.dispatch("setVariablesFormularios", []);
      this.formularioSeleccionado = nombreformulario;
      this.flechaArriba = true;
      this.jsonValorSeleccionado = [];
      this.mostrarRespuestaFormulario = false;
      if (!this.deshabilitado) {
        if (
          this.listaCuestionarios[index].completado == "" &&
          !this.arrayFormulariosLlenados.includes(nombreformulario)
        ) {
          // this.valorSeleccionado = [];
          this.$store.dispatch("setBanderaFormularioExistenteAbierto", false);
          //CREAR COMPONENTE Y CONSULTA SU ESQUEMA
          serverBus.$emit(
            "crearCuestionario",
            this.listaCuestionarios[index].nombre,
            this.listaCuestionarios[index].tipo
          );
          this.banderaOcultarFlecha = true;
        } else {
          this.$store.dispatch(
            "setIdFormulario",
            this.listaCuestionarios[index].completado
          );
          serverBus.$emit(
            "consultarCuestionarioExistente",
            this.listaCuestionarios[index].completado,
            this.listaCuestionarios[index].tipo,
            this.listaCuestionarios[index].nombre
          );
        }
      } else if (this.deshabilitado) {
        this.$store.dispatch(
          "setIdFormulario",
          this.listaCuestionarios[index].completado
        );
        serverBus.$emit(
          "consultarCuestionarioExistente",
          this.listaCuestionarios[index].completado,
          this.listaCuestionarios[index].tipo,
          this.listaCuestionarios[index].nombre
        );
      }
    },
    SeleccionValor(index) {
      if (this.keyFormulario == "seguimiento_epoc_triage") {
        this.jsonValorSeleccionado.splice(4, 1);
      }
      const jsonSeleccion = {
        nombre: "variable" + (index + 1),
        valor: this.valorSeleccionado[index],
      };
      const result = this.jsonValorSeleccionado.filter(
        elemento => elemento.nombre == "variable" + (index + 1)
      )[0];
      if (result) {
        result.valor = this.valorSeleccionado[index];
      } else {
        this.jsonValorSeleccionado.push(jsonSeleccion);
      }
    },
    construirArrayVariablesActualizar() {
        const arrayActualizar = [];
        let m_variablesFormularios = null;
        m_variablesFormularios = this.$store.getters.getVariablesFormularios;
        m_variablesFormularios.map(function(variable) {
          if (variable.valor != null) {
            if (variable.tipo == "numero") {
              const jsonActualizar = {
                nombre: variable.variable,
                valor: Number(variable.valor)
              };
              arrayActualizar.push(jsonActualizar);
            } else {
              const jsonActualizar = {
                nombre: variable.variable,
                valor: variable.valor
              };
              arrayActualizar.push(jsonActualizar);
            }
          }
        });
        this.$store.dispatch("setVariablesActualizadas", arrayActualizar);
        this.actualizarFormularioActual();
      // }
    },
    async actualizarFormularioActual() {
      try {
        this.$store.dispatch("setCargando", true);
        let respuesta = null;
        respuesta = await actualizarFormulario(this.$store.getters.getIdFormulario, this.$store.getters.getNombreFormulario,this.$store.getters.getVariablesActualizadas,this.$store.getters.getColeccion,this.$store.state.provider_email);
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      } finally {
        this.$emit("formularioActualizadoExitosamenteMomento", 'ok');
        
        this.$store.dispatch("setIdFormulario", null);
        this.$store.dispatch("setVariablesFormularios", []);
        this.panel= null
        this.arrayVariablesActualizar=[]
        this.jsonValorSeleccionado = [];
        this.mostrarRespuestaFormulario = false;
        this.$store.dispatch("setVariablesActualizadas", []);
        this.$store.dispatch("setNombreFormulario", null);
        this.$store.dispatch("setCampoIngresado", null);
        this.$store.dispatch("setNombreCampo", null);
        this.$store.dispatch("setCargando", false);
        this.reiniciarPanelExpansible()
      }
    },
  },
  watch: {
    listaCuestionarios() {
      this.arrayFormulariosLlenados = [];
    },
    nombreFormularioCreado: function(valor) {
      if (valor != null) {
        this.arrayFormulariosLlenados.push(valor);
      }
    },
  }
};
</script>
<style lang="scss" scoped src='./CuestionarioSeguimiento.scss'>
</style>


// WEBPACK FOOTER //
// src/components/Seguimiento/CuestionarioSeguimiento/CuestionarioSeguimiento.vue